import type { ReactNode } from 'react';
import AppFooter from './AppFooter';
import AppHeader from './AppHeader';
import styles from './AppShell.module.css';
import ProgressStepper from './ProgressStepper';

interface Props {
  children: ReactNode;
}

export default function AppShell({ children }: Props) {
  return (
    <div className={styles.shell}>
      <AppHeader />
      <ProgressStepper />
      <main className={styles.main}>{children}</main>
      <AppFooter />
    </div>
  );
}
